import { useFormik } from "formik";
import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import Input from "../../../atoms/input";
import Loader from "../../../atoms/loader";

import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import {
  getUserData,
  updateUser,
  uploadImage,
} from "../../../../firebase/firebaseutils";
import { validationSchema } from "./schema";
import { Button } from "@mui/material";
import DoneIcon from "@mui/icons-material/Done";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Modal from "../../../atoms/modal";
import Alert from "../../../atoms/alert";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

const IndividualRegistrationForm = (props) => {
  const params = useParams();
  const uid = params.id;
  let lg = useMediaQuery("(max-width:1000px)");
  let md = useMediaQuery("(max-width:700px)");

  const [currentTeamMember, setCurrentTeamMember] = useState(0);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [error, setError] = useState({ image: "" });
  const [userUpdated, setUserUpdated] = useState(false);
  const [userUpdationError, setUserUpdationError] = useState(false);
  const [handleSave, setHandleSave] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [initialUserData, setInitialUserData] = useState("");

  //fields state
  // const [cnic, setCnic] = useState("");
  // const [instituteN ame, setInstituteName] = useState("");
  // const [instituteAddress, setInstituteAddress] = useState("");
  const [reference, setReference] = useState("");

  //image state
  const [image, setImage] = useState("");
  //dropdown states
  const [committeePreference, setCommitteePreference] = useState("");
  const [committeePreference2, setCommitteePreference2] = useState("");
  const [accommodation, setAccomodation] = useState("No");
  const [gender, setGender] = useState("Male");
  const [newMemberState, setNewMemberState] = useState(
    props.teams?.length ? true : false
  );
  const [disableSubmit, setdisableSubmit] = useState(false);
  useEffect(() => {
    if (userUpdated) {
      setTimeout(() => {
        setUserUpdated(false);
      }, 4000);
    }
  }, [userUpdated]);

  const resetStates = () => {
    setFirstName("");
    setLastName("");
    setEmail("");
    setContact("");
    setImage("");
    setCommitteePreference("");
    setCommitteePreference2("");
    setAccomodation("");
    setGender("Male");
    setReference("");
    formik.values.cnic = "";
    formik.values.instituteAddress = "";
    formik.values.instituteName = "";
  };

  const formik = useFormik({
    initialValues: {
      cnic: "",
      instituteName: "",
      instituteAddress: "",
    },
    onSubmit: async (values) => {
      if (
        !image ||
        !committeePreference ||
        !committeePreference2 ||
        !contact ||
        contact.length < 11 ||
        !firstName ||
        !lastName ||
        !email ||
        email.indexOf("@") == -1
      ) {
        setImage("");
        setError({
          ...error,
          image: !image && "Image is required",
          committeePreference:
            !committeePreference && "Committee Preference is required",
          committeePreference2:
            !committeePreference2 && "Committee Preference 2 is required",
          contact:
            (!contact || contact.length < 11) &&
            " Valid contact number is required.",
          firstName: !firstName && "First name is required.",
          lastName: !firstName && "Last name is required.",
          email:
            (!email && "Email is required.") ||
            (email.indexOf("@") == -1 && "Email format is incorrect"),
        });
      } else if (image) {
        const { cnic, instituteAddress, instituteName } = values;
        setLoading(true);
        setdisableSubmit(false);

        if (handleSave) {
          //incase of "save changes"
          let result = {};
          if (props.isTeams) {
            const newMember = {
              cnic,
              gender,
              instituteName,
              instituteAddress,
              committeePreference,
              committeePreference2,
              accommodation,
              reference,
              firstName: firstName,
              lastName: lastName,
              contact: contact,
              email: email,
              image: image || "",
            };
            var existingMember = props.teams.find(
              (team) =>
                team.cnic == newMember.cnic || team.email == newMember.email
            );
            if (existingMember) {
              for (const key in existingMember) {
                existingMember[key] = newMember[key];
              }
            }

            props.setTeams(
              newMemberState ? [...props.teams, newMember] : [...props.teams]
            );

            const tempTeams = newMemberState
              ? [...props.teams, newMember]
              : [...props.teams];
            setNewMemberState(false);

            if (props.teams.length > 0) {
              newMember.firstName = firstName;
              newMember.lastName = lastName;
              newMember.contact = contact;
              newMember.email = email;
              newMember.image = image;
              result = updateUser(
                {
                  registeredInEvent: false,
                  status: "signed-up",
                  teams: [...tempTeams],
                },
                uid,
                props.isTeams
              );
            } else {
              // result = updateUser(
              //   {
              //     cnic,
              //     image,
              //     accommodation,
              //     committeePreference,
              //     committeePreference2,
              //     gender,
              //     instituteName,
              //     instituteAddress,
              //     reference,
              //     registeredInEvent: false,
              //   },
              //   uid
              // );
              newMember.firstName = firstName;
              newMember.lastName = lastName;
              newMember.contact = contact;
              newMember.email = email;
              newMember.image = image;
              result = updateUser(
                {
                  registeredInEvent: false,
                  status: "signed-up",
                  teams: [...tempTeams],
                },
                uid,
                props.isTeams
              );
            }
          } else {
            result = updateUser(
              {
                cnic,
                image,
                accommodation,
                committeePreference,
                committeePreference2,
                gender,
                instituteName,
                instituteAddress,
                reference,
                registeredInEvent: false,
              },
              uid
            );
          }

          result.then((values) => {
            if (values) {
              setUserUpdated(true);
              setUserUpdationError(false);
              // setLoading(false);
            } else {
              setUserUpdationError(true);
              setUserUpdated(false);
              // setLoading(false);
            }
            window.location.reload(false);
          });
        } else {
          //incase submit is clicked
          let result = {};
          if (props.isTeams) {
            const newMember = {
              cnic,
              gender,
              instituteName,
              instituteAddress,
              committeePreference,
              committeePreference2,
              accommodation,
              reference,
              firstName: initialUserData.firstName,
              lastName: initialUserData.lastName,
              contact: initialUserData.contact,
              email: initialUserData.email,
              image: image || "",
            };
            props.setTeams(
              newMemberState ? [...props.teams, newMember] : [...props.teams]
            );
            const tempTeams = newMemberState
              ? [...props.teams, newMember]
              : [...props.teams];
            if (props.teams.length > 0) {
              newMember.firstName = firstName;
              newMember.lastName = lastName;
              newMember.contact = contact;
              newMember.email = email;
              newMember.image = image;
              result = updateUser(
                {
                  registeredInEvent: "team",
                  status: "form-submitted",
                  teams: [...tempTeams],
                },
                uid,
                props.isTeams
              );
            } else {
              newMember.firstName = firstName;
              newMember.lastName = lastName;
              newMember.contact = contact;
              newMember.email = email;
              newMember.image = image;
              result = updateUser(
                {
                  registeredInEvent: "team",
                  status: "form-submitted",
                  teams: [...tempTeams],
                },
                uid,
                props.isTeams
              );
            }
          } else {
            result = updateUser(
              {
                cnic,
                image,
                accommodation,
                committeePreference,
                committeePreference2,
                gender,
                reference,
                instituteName,
                instituteAddress,
                registeredInEvent: "individual",
                status: "form-submitted",
              },
              uid
            );
          }

          result.then((values) => {
            if (values) {
              setUserUpdated(true);
              setUserUpdationError(false);
              setLoading(false);
            } else {
              setUserUpdationError(true);
              setUserUpdated(false);
              setLoading(false);
            }
            navigate(`/dashboard/${uid}`);
          });
          setNewMemberState(false);
        }
      }
    },
    validationSchema: validationSchema,
  });

  const handleOnSave = () => {
    setHandleSave(true);
  };

  const handleSubmitClick = () => {
    setHandleSave(false);
  };
  //FIELD HANDLERS
  // const handleCnic = (e) => {
  //   setCnic(e.target.value);
  // };
  // const handleInstituteName = (e) => {
  //   setInstituteName(e.target.value);
  // };
  // const handleInstituteAddress = (e) => {
  //   setInstituteAddress(e.target.value);
  // };
  const handleReference = (e) => {
    setReference(e.target.value);
  };

  //DROPDOWN HANDLERS
  const handleGenderChange = (event) => {
    setGender(event.target.value);
  };
  const handleCommitteePreferenceChange = (event) => {
    setCommitteePreference(event.target.value);
    setError({ ...error, committeePreference: "" });
    if (event.target.value == committeePreference2) {
      setCommitteePreference2("");
    }
  };
  const handleCommitteePreference2Change = (event) => {
    setCommitteePreference2(event.target.value);
    setError({ ...error, committeePreference2: "" });
    if (event.target.value == committeePreference) {
      setCommitteePreference("");
    }
  };
  const handleAccomodation = (event) => {
    setAccomodation(event.target.value);
  };

  //
  const handleImageChange = async (event) => {
    if (props.isTeams) {
      let file = event.target.files[0];
      setLoading(true);
      let uploadedUrl = await uploadImage(file);
      setLoading(false);

      setImage(uploadedUrl);
    } else {
      let file = event.target.files[0];
      setImage(file);
    }
  };

  const handleOpenModal = () => {
    setShowModal(true);
  };

  const res = useContext(AppContext);
  let navigate = useNavigate();

  const setLoading = res?.appLoadingStates?.setappLoader;
  const loading = res?.appLoadingStates?.appLoader;
  const user = res?.appLoadingStates?.user;

  useEffect(() => {
    const getUserInitialInfo = async () => {
      setLoading(true);
      const response = await getUserData(user.uid);
      if (response?.error) {
        console.log(response?.error);
        setLoading(false);
      } else {
        if (response?.registeredInEvent) {
          navigate(`/dashboard/${uid}`);
        } else {
          formik.values.cnic = response?.cnic;
          formik.values.instituteName = response?.instituteName;
          formik.values.instituteAddress = response?.instituteAddress;
          setCommitteePreference(
            response?.committeePreference ? response.committeePreference : ""
          );
          // setCommitteePreference2(response?.committeePreference2);
          setCommitteePreference2(
            response?.committeePreference2 ? response.committeePreference2 : ""
          );
          setAccomodation(
            response?.accomodation ? response.accomodation : "No"
          );
          setImage(response?.imageUrl);

          setInitialUserData(response);
          setFirstName(response.firstName);
          setLastName(response.lastName);
          setContact(response.contact);
          setEmail(response.email);
        }
        const firstTeamMember = {
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.email,
          gender: response.gender,
          contact: response.contact,
          committeePreference: response.committeePreference,
          committeePreference2: response.committeePreference2,
          cnic: response.cnic,
          accommodation: response.accommodation,
          instituteAddress: response.instituteAddress,
          instituteName: response.instituteName,
          reference: response.reference,
        };
        if (response.teams && props.isTeams)
          props.setTeams([...response.teams]);
        setLoading(false);
      }
    };
    if (user) {
      getUserInitialInfo();
      //   const userData = getUserData(user.user.uid);
    }
    // else {
    // navigate("/");
    // }
  }, [user]);

  useEffect(() => {
    if (props.isTeams) {
      const currentMember = props.teams[currentTeamMember || 0];
      setNewMemberState(!props.teams?.length ? true : false);
      if (currentMember) {
        setAccomodation(currentMember.accommodation);
        setFirstName(currentMember.firstName);
        setLastName(currentMember.lastName);
        setCommitteePreference(currentMember.committeePreference);
        setCommitteePreference2(currentMember.committeePreference2);
        setGender(currentMember.gender);
        formik.values.instituteAddress = currentMember.instituteAddress;
        formik.values.instituteName = currentMember.instituteName;
        formik.values.cnic = currentMember.cnic;
        setReference(currentMember.reference);
        setImage(currentMember?.image || "");
        setEmail(currentMember?.email);
        setContact(currentMember?.contact);
      }
    }
  }, [currentTeamMember, props.teams]);

  if (loading) return <Loader />;

  if (loading) return <Loader />;
  return (
    <>
      {props.isTeams ? (
        <>
          <form
            onSubmit={formik.handleSubmit}
            style={{
              position: "relative",
              marginTop: "40px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
              }}
            >
              <Input
                id="firstName"
                name="firstName"
                label="First Name"
                value={
                  props.teams.length == 0
                    ? initialUserData?.firstName
                    : firstName
                }
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                disabled={props.teams.length == 0}
                onChange={(e) => {
                  setFirstName(e.target.value);
                }}
                error={!!error.firstName}
                helperText={error.firstName}
              />
              <Input
                id="lastName"
                name="lastName"
                label="Last Name"
                value={
                  props.teams.length == 0 ? initialUserData?.lastName : lastName
                }
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                disabled={props.teams.length == 0}
                onChange={(e) => {
                  setLastName(e.target.value);
                }}
                error={!!error.lastName}
                helperText={error.lastName}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
                marginTop: "15px",
              }}
            >
              <Input
                id="email"
                name="email"
                label="Email Address"
                value={props.teams.length == 0 ? initialUserData?.email : email}
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                disabled={props.teams.length == 0}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                error={!!error.email}
                helperText={error.email}
              />
              <Input
                id="contact"
                name="contact"
                label="Contact Number"
                value={
                  props.teams.length == 0 ? initialUserData?.contact : contact
                }
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                style={{ marginLeft: lg ? "" : "20px", marginBottom: "15px" }}
                // type="number"
                disabled={props.teams.length == 0}
                onChange={(e) => {
                  if (!isNaN(e.target.value)) setContact(e.target.value);
                }}
                error={!!error.contact}
                helperText={error.contact}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
              }}
            >
              <div>
                <Input
                  name="cnic"
                  label="cnic"
                  value={formik.values.cnic}
                  onChange={formik.handleChange}
                  error={formik.touched.cnic && Boolean(formik.errors.cnic)}
                  helperText={formik.touched.cnic && formik.errors.cnic}
                  onBlur={formik.handleBlur}
                  height="5rem"
                  width={lg ? "22rem" : "30rem"}
                  // type="number"
                />
              </div>
              <Box sx={{ width: lg ? "22rem" : "30rem" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={gender}
                    label="Gender"
                    onChange={handleGenderChange}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                    <MenuItem value="Prefer Not To Say">
                      Prefer Not To Say
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div>
              <Input
                id="instituteName"
                name="instituteName"
                label="Institute Name"
                value={formik.values.instituteName}
                onChange={formik.handleChange}
                error={
                  formik.touched.instituteName &&
                  Boolean(formik.errors.instituteName)
                }
                helperText={
                  formik.touched.instituteName && formik.errors.instituteName
                }
                onBlur={formik.handleBlur}
                height="5rem"
                style={{ width: lg ? "22rem" : "100%", marginTop: "15px" }}
                type="text"
              />
            </div>
            <div style={{ marginTop: "15px" }}>
              <Input
                id="instituteAddress"
                name="instituteAddress"
                label="Institute Address"
                value={formik.values.instituteAddress}
                onChange={formik.handleChange}
                error={
                  formik.touched.instituteAddress &&
                  Boolean(formik.errors.instituteAddress)
                }
                helperText={
                  formik.touched.instituteAddress &&
                  formik.errors.instituteAddress
                }
                onBlur={formik.handleBlur}
                height="5rem"
                width="15rem"
                type="text"
                style={{ width: lg ? "22rem" : "100%" }}
              />
            </div>
            <div>
              <Box
                sx={{
                  marginTop: "15px",
                  minWidth: lg ? "22rem" : 120,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Committee Preference 1
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={committeePreference}
                    label="Committee Preference 1"
                    onChange={handleCommitteePreferenceChange}
                    required={true}
                  >
                    <MenuItem value="DISEC">DISEC</MenuItem>
                    <MenuItem value="SPECPOL">SPECPOL</MenuItem>
                    <MenuItem value="SOCHUM">SOCHUM</MenuItem>
                    <MenuItem value="UNHCR">UNHCR</MenuItem>
                    <MenuItem value="UNCSW">UNCSW</MenuItem>
                    <MenuItem value="COP">COP</MenuItem>
                    <MenuItem value="International Federation of Association Football (FIFA)">
                      International Federation of Association Football (FIFA)
                    </MenuItem>
                    <MenuItem value="UNSC">UNSC</MenuItem>
                    <MenuItem value="Historical PNA">Historical PNA</MenuItem>
                    {/* <MenuItem value="Council For Disability Inclusion">
                      Council For Disability Inclusion
                    </MenuItem> */}
                  </Select>
                  {error.committeePreference ? (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error.committeePreference}
                    </p>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Box>
            </div>
            <div>
              <Box
                sx={{
                  marginTop: "40px",
                  minWidth: lg ? "22rem" : 120,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Committee Preference 2
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    label="Committee Preference"
                    id="committeePreference2"
                    name="committeePreference2"
                    value={committeePreference2}
                    onChange={handleCommitteePreference2Change}
                  >
                    <MenuItem value="DISEC">DISEC</MenuItem>
                    <MenuItem value="SPECPOL">SPECPOL</MenuItem>
                    <MenuItem value="SOCHUM">SOCHUM</MenuItem>
                    <MenuItem value="UNHCR">UNHCR</MenuItem>
                    <MenuItem value="UNCSW">UNCSW</MenuItem>
                    <MenuItem value="COP">COP</MenuItem>
                    <MenuItem value="International Federation of Association Football (FIFA)">
                      International Federation of Association Football (FIFA)
                    </MenuItem>
                    <MenuItem value="UNSC">UNSC</MenuItem>
                    {/* <MenuItem value="Historical PNA">Historical PNA</MenuItem> */}
                    <MenuItem value="Historical PNA">Historical PNA</MenuItem>
                    {/* <MenuItem value="Council For Disability Inclusion">
                      Council For Disability Inclusion
                    </MenuItem> */}
                  </Select>
                  {error.committeePreference2 ? (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error.committeePreference2}
                    </p>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Box>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
                marginTop: "15px",
              }}
            >
              <Box sx={{ width: lg ? "22rem" : "30rem", marginTop: "25px" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Accomodation
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    label="Accomodation"
                    id="accomodation"
                    name="accommodation"
                    value={accommodation}
                    onChange={handleAccomodation}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Input
                id="reference"
                name="reference"
                label="reference"
                value={reference}
                onChange={handleReference}
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                style={{ marginTop: "25px" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
                flexFlow: "column",
              }}
            >
              <Button
                variant="contained"
                component="label"
                endIcon={image ? <DoneIcon /> : ""}
                sx={{
                  paddingLeft: "32px",
                  paddingRight: "32px",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  background: "#610000",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#813333",
                  },
                }}
              >
                {!image ? "Upload Photograph" : "Photograph Uploaded"}
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={handleImageChange}
                />
              </Button>
              {error.image && !image ? (
                <p
                  style={{ color: "red", fontSize: "14px", marginLeft: "10px" }}
                >
                  image is required
                </p>
              ) : (
                ""
              )}
            </div>
            <p>{props.teams.length} members.</p>
            <div
              style={{
                marginTop: "40px",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexFlow: md ? "column" : "row",
                }}
              >
                <Button
                  variant="text"
                  color="warning"
                  startIcon={<ArrowBackIcon />}
                  sx={{ fontWeight: 600 }}
                  onClick={() => {
                    if (!currentTeamMember) {
                      handleOpenModal();
                    } else {
                      setCurrentTeamMember(currentTeamMember - 1);
                      setError({});
                    }
                  }}
                >
                  Back
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    fontWeight: 600,
                    marginLeft: "16px",
                    marginTop: md ? "30px" : 0,
                  }}
                  type="submit"
                  onClick={handleSubmitClick}
                  disabled={props.teams.length <= 1 || disableSubmit}
                >
                  SUBMIT
                </Button>
                <Button
                  variant="outlined"
                  sx={{
                    fontWeight: 600,
                    marginLeft: "16px",
                    marginTop: md ? "30px" : 0,
                  }}
                  onClick={() => {
                    handleOnSave();
                  }}
                  type="submit"
                >
                  SAVE CHANGES
                </Button>
                {props.teams.length > 1 && (
                  <Button
                    variant="text"
                    sx={{
                      fontWeight: 600,
                      marginLeft: "16px",
                      marginTop: md ? "30px" : 0,
                    }}
                    // type="submit"
                    endIcon={<ArrowForwardIcon />}
                    onClick={() => {
                      // resetStates();
                      setCurrentTeamMember(currentTeamMember + 1);
                    }}
                    disabled={props.teams.length - 1 == currentTeamMember}
                  >
                    NEXT
                  </Button>
                )}
              </div>

              <div>
                <Button
                  variant="contained"
                  sx={{
                    fontWeight: 600,
                    marginLeft: "16px",
                    background: "#610000",
                    "&:hover": {
                      backgroundColor: "#813333",
                    },
                  }}
                  // type="submit"
                  onClick={() => {
                    resetStates();
                    setNewMemberState(true);
                    setUserUpdated(false);
                    setdisableSubmit(true);
                    setError({});
                  }}
                  disabled={props.teams.length == 10}
                >
                  Add New Member
                </Button>
              </div>
            </div>
          </form>
          <Modal
            message="Are you sure you want to go back? You'll lose all your unsaved information."
            open={showModal}
            setShowModal={setShowModal}
          />
          <div>
            {userUpdated ? (
              <Alert message="Changes saved successfully." severity="success" />
            ) : (
              ""
            )}
          </div>
          <div>
            {userUpdationError ? (
              <Alert message="error occured" severity="error" />
            ) : (
              ""
            )}
          </div>
        </>
      ) : (
        <>
          <form
            onSubmit={formik.handleSubmit}
            style={{
              position: "relative",
              marginTop: "40px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
              }}
            >
              <Input
                id="firstName"
                name="firstName"
                label="First Name"
                value={initialUserData?.firstName}
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                disabled={true}
              />
              <Input
                id="lastName"
                name="lastName"
                label="Last Name"
                value={initialUserData?.lastName}
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                disabled={true}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
                marginTop: "15px",
              }}
            >
              <Input
                id="email"
                name="email"
                label="Email Address"
                value={initialUserData?.email || ""}
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                disabled={true}
              />
              <Input
                id="contact"
                name="contact"
                label="Contact Number"
                value={initialUserData?.contact || ""}
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                style={{ marginLeft: lg ? "" : "20px", marginBottom: "15px" }}
                type="number"
                disabled={true}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
              }}
            >
              <div>
                <Input
                  name="cnic"
                  label="cnic"
                  value={formik.values.cnic}
                  onChange={formik.handleChange}
                  error={formik.touched.cnic && Boolean(formik.errors.cnic)}
                  helperText={formik.touched.cnic && formik.errors.cnic}
                  onBlur={formik.handleBlur}
                  height="5rem"
                  width={lg ? "22rem" : "30rem"}
                  type="number"
                />
              </div>
              <Box sx={{ width: lg ? "22rem" : "30rem" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Gender</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={gender}
                    label="Gender"
                    onChange={handleGenderChange}
                  >
                    <MenuItem value="Male">Male</MenuItem>
                    <MenuItem value="Female">Female</MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                    <MenuItem value="Prefer Not To Say">
                      Prefer Not To Say
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </div>
            <div>
              <Input
                id="instituteName"
                name="instituteName"
                label="Institute Name"
                value={formik.values.instituteName}
                onChange={formik.handleChange}
                error={
                  formik.touched.instituteName &&
                  Boolean(formik.errors.instituteName)
                }
                helperText={
                  formik.touched.instituteName && formik.errors.instituteName
                }
                onBlur={formik.handleBlur}
                height="5rem"
                style={{ width: lg ? "22rem" : "100%", marginTop: "15px" }}
                type="text"
              />
            </div>
            <div style={{ marginTop: "15px" }}>
              <Input
                id="instituteAddress"
                name="instituteAddress"
                label="Institute Address"
                value={formik.values.instituteAddress}
                onChange={formik.handleChange}
                error={
                  formik.touched.instituteAddress &&
                  Boolean(formik.errors.instituteAddress)
                }
                helperText={
                  formik.touched.instituteAddress &&
                  formik.errors.instituteAddress
                }
                onBlur={formik.handleBlur}
                height="5rem"
                width="15rem"
                type="text"
                style={{ width: lg ? "22rem" : "100%" }}
              />
            </div>
            <div>
              <Box
                sx={{
                  marginTop: "15px",
                  minWidth: lg ? "22rem" : 120,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Committee Preference 1
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={committeePreference}
                    label="Committee Preference 1"
                    onChange={handleCommitteePreferenceChange}
                    required={true}
                  >
                    <MenuItem value="DISEC">DISEC</MenuItem>
                    <MenuItem value="SPECPOL">SPECPOL</MenuItem>
                    <MenuItem value="SOCHUM">SOCHUM</MenuItem>
                    <MenuItem value="UNHCR">UNHCR</MenuItem>
                    <MenuItem value="UNCSW">UNCSW</MenuItem>
                    <MenuItem value="COP">COP</MenuItem>
                    <MenuItem value="International Federation of Association Football (FIFA)">
                      International Federation of Association Football (FIFA)
                    </MenuItem>
                    <MenuItem value="UNSC">UNSC</MenuItem>
                    <MenuItem value="Historical PNA">Historical PNA</MenuItem>
                    <MenuItem value="Council For Disability Inclusion">
                      Council For Disability Inclusion
                    </MenuItem>
                  </Select>
                  {error.committeePreference ? (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error.committeePreference}
                    </p>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Box>
            </div>
            <div>
              <Box
                sx={{
                  marginTop: "40px",
                  minWidth: lg ? "22rem" : 120,
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Committee Preference 2
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    label="Committee Preference"
                    id="committeePreference2"
                    name="committeePreference2"
                    value={committeePreference2}
                    onChange={handleCommitteePreference2Change}
                  >
                    <MenuItem value="DISEC">DISEC</MenuItem>
                    <MenuItem value="SPECPOL">SPECPOL</MenuItem>
                    <MenuItem value="SOCHUM">SOCHUM</MenuItem>
                    <MenuItem value="UNHCR">UNHCR</MenuItem>
                    <MenuItem value="UNCSW">UNCSW</MenuItem>
                    <MenuItem value="COP">COP</MenuItem>
                    <MenuItem value="International Federation of Association Football (FIFA)">
                      International Federation of Association Football (FIFA)
                    </MenuItem>
                    <MenuItem value="UNSC">UNSC</MenuItem>
                    <MenuItem value="Historical PNA">Historical PNA</MenuItem>
                    <MenuItem value="Historical PNA">Historical PNA</MenuItem>
                    <MenuItem value="Council For Disability Inclusion">
                      Council For Disability Inclusion
                    </MenuItem>
                  </Select>
                  {error.committeePreference2 ? (
                    <p style={{ color: "red", fontSize: "10px" }}>
                      {error.committeePreference2}
                    </p>
                  ) : (
                    ""
                  )}
                </FormControl>
              </Box>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: lg ? "" : "space-between",
                flexFlow: lg ? "column" : "row",
                marginTop: "15px",
              }}
            >
              <Box sx={{ width: lg ? "22rem" : "30rem", marginTop: "25px" }}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Accomodation
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    label="Accomodation"
                    id="accomodation"
                    name="accommodation"
                    value={accommodation}
                    onChange={handleAccomodation}
                  >
                    <MenuItem value="Yes">Yes</MenuItem>
                    <MenuItem value="No">No</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <Input
                id="reference"
                name="reference"
                label="reference"
                value={reference}
                onChange={handleReference}
                height="5rem"
                width={lg ? "22rem" : "30rem"}
                style={{ marginTop: "25px" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "10px",
                flexFlow: "column",
              }}
            >
              <Button
                variant="contained"
                component="label"
                endIcon={image ? <DoneIcon /> : ""}
                sx={{
                  paddingLeft: "32px",
                  paddingRight: "32px",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  background: "#610000",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: "#813333",
                  },
                }}
              >
                {!image ? "Upload Photograph" : "Photograph Uploaded"}
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={handleImageChange}
                />
              </Button>
              {error.image && !image ? (
                <p
                  style={{ color: "red", fontSize: "14px", marginLeft: "10px" }}
                >
                  image is required
                </p>
              ) : (
                ""
              )}
            </div>

            <div
              style={{
                marginTop: "90px",
                display: "flex",
                flexFlow: md ? "column" : "row",
              }}
            >
              <Button
                variant="text"
                color="warning"
                startIcon={<ArrowBackIcon />}
                sx={{ fontWeight: 600 }}
                onClick={handleOpenModal}
              >
                Back
              </Button>
              <Button
                variant="contained"
                color="success"
                sx={{ fontWeight: 600, marginLeft: "16px" }}
                type="submit"
                onClick={handleSubmitClick}
              >
                SUBMIT
              </Button>
              <Button
                variant="text"
                sx={{ fontWeight: 600, marginLeft: "16px" }}
                onClick={handleOnSave}
                type="submit"
              >
                SAVE CHANGES
              </Button>
            </div>
          </form>
          <Modal
            message="Are you sure you want to go back? You'll lose all your unsaved information."
            open={showModal}
            setShowModal={setShowModal}
          />
          <div>
            {userUpdated ? (
              <Alert message="Changes saved successfully." severity="success" />
            ) : (
              ""
            )}
          </div>
          <div>
            {userUpdationError ? (
              <Alert message="error occured" severity="error" />
            ) : (
              ""
            )}
          </div>
        </>
      )}
    </>
  );
};

export default IndividualRegistrationForm;
